import { Formik, FormikHelpers, FormikProps } from "formik";
import React, { memo, useCallback } from "react";

import { FormikForm } from "@/formikComponents";
import { profileRoleSectionValidationSchema } from "@/views/components/ConsultantProfile/SuggestedData";
import {
  FormikConsultantProfileRoleSection,
  IConsultantProfileRoleSectionProps,
} from "@/views/ConsultantProfiles/Detail/GeneralSection/RoleSectionEdit";
import {
  IProfileFormikProps,
  profilePartialUpdaterBuilder,
} from "@/views/ConsultantProfiles/Detail/profilePartialUpdaterBuilder";
import { ROLE_MESSENGER_CONTEXT } from "@/views/ConsultantProfiles/Detail/RoleSection/RoleForm";

import { Buttons } from "./Buttons";

interface IProfileRoleValues {
  roles: IConsultantProfileRoleSectionProps["value"];
}

interface RoleFormProps extends IProfileFormikProps<IProfileRoleValues> {
  showCompanyPosition: boolean;
}

const RoleForm = memo<RoleFormProps>(
  ({ initialValues, validationSchema: vs, onSubmit, onCancel, showCompanyPosition }) => {
    const handleSubmit = useCallback(
      (values: IProfileRoleValues, actions: FormikHelpers<IProfileRoleValues>) => {
        onSubmit(values, actions);
      },
      [onSubmit],
    );

    return (
      <Formik initialValues={initialValues} validationSchema={vs} onSubmit={handleSubmit}>
        {(form: FormikProps<IProfileRoleValues>) => (
          <>
            <FormikForm>
              <FormikConsultantProfileRoleSection
                showCompanyPosition={showCompanyPosition}
                name="role"
                value={form.values.roles}
                form={form}
              />
              <Buttons form={form} onClose={onCancel} />
            </FormikForm>
          </>
        )}
      </Formik>
    );
  },
);

export const RoleFormik = profilePartialUpdaterBuilder(RoleForm, {
  validationSchema: profileRoleSectionValidationSchema,
  messengerContext: ROLE_MESSENGER_CONTEXT,
});
